export const iconFontAwesomeGamingXbox = (
	<i className="fa-solid fa-xbox"></i>
);
